import React from "react";
import SkeletonLoader from "../Shimmer";
import { createArrayUpto } from "../../utils/commonHelper";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './shimmer.css';
const GroupsListingShimmer = () => {
  return (
    <div className="explore_card">
      {createArrayUpto(6)?.map((data, index) => (
        <div
          className="card_grp"
          key={index}
          style={{
            marginBottom: "20px", // Space between rows
          }}
        >
          <SkeletonLoader type={"card"} />
        </div>
      ))}
    </div>
  );
};

export default GroupsListingShimmer;



export const GroupCardSkeleton = ({ count = 5 }) => {
  return (
    <>
      {Array(count)
        .fill(0)
        .map((_, index) => (
          <div key={index} className="group-card-skeleton p-0" style={{ borderBottom: "unset" }} >
            <div className="skeleton-card health_hub_img pe-2">
              <div className="image-container">
                <Skeleton height={50} width={50} />
              </div>
              <div className="text-container">
                <h6>
                  <Skeleton width="70%" />
                </h6>
                <p style={{ marginBottom: "0px" }}>
                  <Skeleton width="40%" />
                </p>
              </div>
              <div>
                <div className="mb-2">
                  <Skeleton width={60} height={20} />
                </div>
                <div className="text-center">
                  <Skeleton circle height={20} width={20} />
                </div>
              </div>
            </div>

            <div className="skeleton-card health_hub_img pe-2">
              <div className="image-container">
                <Skeleton height={50} width={50} />
              </div>
              <div className="text-container">
                <h6>
                  <Skeleton width="70%" />
                </h6>
                <p style={{ marginBottom: "0px" }}>
                  <Skeleton width="40%" />
                </p>
              </div>
              <div>
                <div className="mb-2">
                  <Skeleton width={60} height={20} />
                </div>
                <div className="text-center">
                  <Skeleton circle height={20} width={20} />
                </div>
              </div>
            </div>

          </div>
        ))}
    </>
  );
};
